import { render, staticRenderFns } from "./V3CredentialForm.vue?vue&type=template&id=31749a19"
import script from "./V3CredentialForm.vue?vue&type=script&lang=js"
export * from "./V3CredentialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports